import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Post-Launch',
  subtitle: 'Sieh dir die Go-Live-Checkliste an und lege das Post-Launch-Screening-Datum fest.',
  go_live_checklist: {
    labels: {
      yes: 'Ja',
      no: 'Nein',
    },
    title: 'Go-Live-Checkliste',
    form: {
      is_google_business_available: {
        label: 'Google Business verfügbar',
      },
      is_smart_pricing_configured: {
        label: 'Günstigere Preise als bei Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Promo-Flyer versendet',
      },
      is_menu_fully_configured: {
        label: 'Alle Menüpunkte verfügbar',
      },
      has_offers_on_competitor_platforms: {
        label: 'Hat das Restaurant aktive Angebote auf Wolt, Uber oder Lieferando (außer kostenloser Lieferung)?',
      },
      is_instagram_story_shared: {
        label: 'Instagram-Story mit dem Inhaber geteilt',
      },
      is_order_system_connected_to_website: {
        label: 'Foodamigos-Website verbunden ODER Online-Bestellbutton auf der Restaurant-Website hinzugefügt',
      },
      google_business_connected_by: {
        label: 'Wie haben wir Zugriff auf das Google-Business-Profil erhalten?',
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Sales Manager hat google@foodamigos.io eingeladen',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Sales Manager hat die erste Anfrage selbst vom Telefon des Inhabers gesendet',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            'Onboarding Manager hat das Google-Business-Profil angefragt (SM hat weder eingeladen noch Zugriff angefordert)',
          null: 'N/A',
        },
      },
    },
    buttons: {
      save: 'Speichern',
    },
    toasts: {
      success: 'Erfolgreich gespeichert',
      error: 'Speichern fehlgeschlagen',
    },
  },
  post_launch_screening: {
    title: 'Post-Launch-Screening',
    form: {
      screening_date: {
        label: 'Screening-Datum',
      },
    },
    toasts: {
      success: 'Erfolgreich gespeichert',
      error: 'Speichern fehlgeschlagen',
    },
    buttons: {
      save: 'Speichern',
    },
  },
};
